import {createSelector} from 'helpers';
import {occurance} from 'store/calendar/selectors/occurance';
import {allActivities, milestones, starting_date, target_date, activities} from './goal';

export const stats = createSelector(
  [ occurance.dependencies, milestones, allActivities, starting_date, target_date, activities ],
  ( ...data ) => data,
  { memoizeOptions: { maxSize: 100 } },
);
